export const isRouteActive = (pathname = "", target = "") => {
  if (!pathname || !target) return false;
  if (pathname === target) return true;

  return pathname.startsWith(`${target}/`);
};

export const isMenuItemActive = (pathname, item) => {
  if (!item) return false;

  if (item.links && item.links.length > 0) {
    return item.links.some((link) => isRouteActive(pathname, link.to));
  }

  if (item.sublink) {
    return isRouteActive(pathname, item.sublink);
  }

  return isRouteActive(pathname, item.to);
};
